import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  InputSignal,
  InputSignalWithTransform,
  output,
  OutputEmitterRef,
  ViewEncapsulation
} from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { NAVIGATION_TOKEN, NavigationProvider } from '@core';
import { Router } from '@angular/router';
import { OrIconComponent } from '../../or-icon/or-icon.component';

@Component({
  selector: 'lib-title-navbar',
  templateUrl: './title-navbar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [IonicModule, OrIconComponent]
})
export class TitileNavbarComponent {
  readonly customBackUrl: InputSignal<string | undefined> = input<string | undefined>();
  readonly showDots: InputSignal<boolean | undefined> = input<boolean | undefined>(false);
  readonly showBackArrow: InputSignal<boolean | undefined> = input<boolean | undefined>(true);
  readonly interceptBack: InputSignal<boolean | undefined> = input<boolean | undefined>(false);
  readonly showRandomize: InputSignal<boolean | undefined> = input<boolean | undefined>(false);
  readonly showRankQAIcon: InputSignal<boolean | undefined> = input<boolean | undefined>(false);
  readonly title: InputSignal<string | null> = input<string | null>(null);
  readonly extended: InputSignalWithTransform<boolean, unknown> = input(false, { transform: booleanAttribute });

  readonly actionOnBack: OutputEmitterRef<void> = output<void>();
  readonly onDotsClicked: OutputEmitterRef<void> = output<void>();
  readonly onSettingsClicked: OutputEmitterRef<void> = output<void>();
  readonly onRandomizeClicked: OutputEmitterRef<void> = output<void>();
  readonly onAddGameOpened: OutputEmitterRef<void> = output<void>();
  readonly onMessageClicked: OutputEmitterRef<void> = output<void>();
  readonly onRankQAClicked: OutputEmitterRef<void> = output<void>();

  private readonly navigationProvider: NavigationProvider = inject(NAVIGATION_TOKEN);
  private readonly router: Router = inject(Router);

  goBack(): void | Promise<boolean> {
    const customUrl: string | undefined = this.customBackUrl();
    if (customUrl) return this.router.navigate([customUrl]);

    this.actionOnBack.emit();

    if (this.interceptBack()) return;

    return this.navigationProvider.back();
  }

  dotsClicked(): void {
    this.onDotsClicked.emit();
  }

  randomizeClicked(): void {
    this.onRandomizeClicked.emit();
  }

  showRankQA(): void {
    this.onRankQAClicked.emit();
  }
}
